import { createContext, useContext, useEffect, useReducer } from "react";
import {
  articleReducer,
  INITIAL_STATE,
  types,
} from "../../reducers/inventory/articleReducer";
import axiosClient from "../../api/axios";
import axios from "axios";
import Swal from "sweetalert2";
import {
  alertSuccess,
  showAlert,
  showTypeErrorFetch,
} from "../../utilities/alerts.utilities";
import { LOADED, STATUS_NOT_LOADED } from "../../api/constant";
import { useParams } from "react-router-dom";
import { formatNumberCOP } from "../../utilities/app.utilities";
const ArticleFormContext = createContext({});
const ArticleFormProvider = ({ children }) => {
  const { item_id } = useParams();
  const [state, dispatch] = useReducer(articleReducer, INITIAL_STATE);
  useEffect(() => {
    if (item_id != null && item_id != "null") {
      loadArticle(item_id);
    } else {
      cleanArticle();
    }
  }, [item_id]);
  useEffect(() => {
    if ((state.article.name.length>3||state.article.code.length>3) && item_id === "null") {
      axiosClient()
      .get(`inventory/getHeadersItemByNameAndCode`,{
        params: {
          name: state.article.name,
          code: state.article.code
        }
      })
      .then(({ data }) => {
        dispatch({
          type: types.CHANGE_INPUT_ARTICLE,
          payload: { name:'lookedItems', value: data},
        });
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
    }
  }, [state.article.name,state.article.code]);
  useEffect(() => {
    if (
      state.article.id &&
      state.article.observation.status === STATUS_NOT_LOADED
    ) {
      axiosClient()
        .get(`inventory/header_item/${state.article.id}/getObservations`)
        .then(({ data }) => {
          dispatch({
            type: types.OBSERVATIONS_LOADED,
            payload: data,
          });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  }, [state.article.observation.status, state.article.id]);
  useEffect(() => {
    if (
      state.article.itemsCheckMeasure.status === STATUS_NOT_LOADED &&
      state.article.id
    ) {
      axiosClient()
        .get(`inventory/getMeasuresCheck/${state.article.id}`)
        .then(({ data }) => {
          dispatch({ type: types.MEASURES_CHECK_LOADED, payload: data });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  }, [state.article.itemsCheckMeasure.status, state.article.id]);
  useEffect(() => {
    if (state.article.id) {
      axiosClient()
        .get(`inventory/getMovements/${state.article.id}`, {
          params: state.article.movements.filter,
        })
        .then(({ data }) => {
          dispatch({
            type: types.MOVEMENTS_LOADED,
            payload: { elements: data.movements, rows: data.rows },
          });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  }, [
    state.article.movements.status,
    state.article.id,
    state.article.movements.filter.page,
  ]);
  //if change filter we have to reset page to getMovements
  useEffect(() => {
    if (state.article.movements.filter.page !== 1) {
      dispatch({
        type: types.CHANGE_INPUT_FILTER_MOVEMENTS,
        payload: { name: "page", value: 1 },
      });
    } else {
      dispatch({
        type: types.RELOAD_MOVEMENTS_BY_FILTER,
      });
    }
  }, [
    state.article.movements.filter.warehouses_id,
    state.article.movements.filter.responsables_id,
    state.article.movements.filter.init_date,
    state.article.movements.filter.end_date,
    state.article.movements.filter.type_code,
    state.article.movements.filter.types_detail,

  ]);
  
  useEffect(() => {
    if (state.article.id) {
      axiosClient()
        .get(`inventory/getInventoryGroup/${state.article.id}`, {
          params: state.article.inventory.filter,
        })
        .then(({ data }) => {
          dispatch({
            type: types.SET_INVENTORY_ITEMS,
            payload: { ...state.article.inventory, items: data },
          });
          dispatch({type: types.SET_INVENTORY_ITEMS_INITIAL});
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  }, [state.article.id, state.article.inventory.filter]);

  useEffect(() => {
    if (state.article.id) {
      axiosClient()
        .get(`inventory/getMeasureMainFromArticleId/${state.article.id}`)
        .then(({ data }) => {
          dispatch({
            type: types.SET_MEASURE_ARTICLE,
            payload: data[0].name,
          });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  }, [state.article.id]);

  useEffect(() => {
    if (
      state.article.documents.status === STATUS_NOT_LOADED &&
      state.article.id
    ) {
      axiosClient()
        .get(`security/getUsers`)
        .then(({ data }) => {
          dispatch({ type: types.USERS_LOADED, payload: data });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  }, [state.article.users.status, state.article.id]);
  useEffect(() => {
    if (
      state.article.warehouses.status === STATUS_NOT_LOADED &&
      state.article.id
    ) {
      axiosClient()
        .get(`inventory/getWarehouses`)
        .then(({ data }) => {
          dispatch({ type: types.WAREHOUSES_LOADED, payload: data });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  }, [state.article.warehouses.status, state.article.id]);
  useEffect(() => {
    if (
      state.article.documents.status === STATUS_NOT_LOADED &&
      state.article.id
    ) {
      axiosClient()
        .get(`inventory/header_item/${state.article.id}/documents`)
        .then(({ data }) => {
          dispatch({ type: types.DOCUMENTS_LOADED, payload: data });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  }, [state.article.documents.status, state.article.id]);

  const createArticle = () => {
    axiosClient()
      .post(`inventory/createArticle`, {
        code: state.article.code,
        name: state.article.name,
        description: state.article.description,
        has_lote: state.article.has_lote,
        has_date_made: state.article.has_date_made,
        has_date_expired: state.article.has_date_expired,
      })
      .then(({ data }) => {
        dispatch({
          type: types.CHANGE_OBJECT_ARTICLE,
          payload: {
            ...state.article,
            id: data.id,
            type: data.type,
            created_at: data.created_at,
            to_edit: false,
          },
        });
        alertSuccess("Cambios realizados satisfactoriamente");
        if (!data.type) {
          showAlert(
            "Artículo sin unidad de medida",
            "Se debe definir unidad de medida para usar este artículo en la pestaña «Tipo de medida».",
            null,
            null
          );
        }
      })
      .catch((e) => {
        /* dispatch({
          type: types.CHANGE_INPUT_ENTRY,
          payload: { name: "status", value: STATUS_NOT_LOADED },
        }); */
        showTypeErrorFetch(e);
      });
  };
  const uploadFilesDataSheet = async (pictures) => {
    for await (const document of pictures) {
      var formData = new FormData();
      formData.append("document", document);
      await axiosClient()
        .post(`inventory/header_item/${state.article.id}/documented`, formData)
        .then(({ data }) => {
          return data;
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
    dispatch({ type: types.RELOAD_DOCUMENTS });
  };
  const loadMeasures = () => {
    return axiosClient()
      .get(`inventory/getMeasures`)
      .then(({ data }) => {
        return data;
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };
  const loadArticle = async (load_item_id) => {
    const measures = await loadMeasures();
    axiosClient()
      .get(`inventory/getArticle/${load_item_id}`)
      .then(({ data }) => {
        dispatch({
          type: types.CHANGE_OBJECT_ARTICLE,
          payload: {
            ...state.article,
            id: load_item_id,
            name: data.name,
            code: data.code,
            type: data.type,
            has_lote: data.has_lote,
            has_date_made: data.has_date_made,
            has_date_expired: data.has_date_expired,
            created_at: data.created_at,
            updated_at: data.updated_at,
            description: data.description,
            to_edit: false,
            measures: {
              ...state.article.measures,
              status: LOADED,
              elements: measures,
            },
            itemsCheckMeasure: {
              ...state.article.itemsCheckMeasure,
              status: STATUS_NOT_LOADED,
            },
            observation: {
              ...state.article.observation,
              status: STATUS_NOT_LOADED,
            },
            documents: {
              ...state.article.documents,
              status: STATUS_NOT_LOADED,
            },
          },
        });
        if (!data.type) {
          showAlert(
            "Artículo sin unidad de medida",
            "Se debe definir unidad de medida para usar este artículo en la pestaña «Tipo de medida».",
            null,
            null
          );
        }
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });

    dispatch({
      type: types.RELOAD_DOCUMENTS,
      payload: load_item_id,
    });
  };
  const cleanArticle = async () => {
    const measures = await loadMeasures();

    dispatch({
      type: types.CHANGE_OBJECT_ARTICLE,
      payload: {
        ...state.article,
        id: null,
        name: "",
        code: "",
        type: "",
        has_lote: false,
        has_date_made: false,
        has_date_expired: false,
        description: "",
        to_edit: true,
        measures: {
          ...state.article.measures,
          status: LOADED,
          elements: measures,
        },
        observation: {
          text: "",
          status: STATUS_NOT_LOADED,
          observations: [],
        },
        documents: {
          status: STATUS_NOT_LOADED,
          elements: [],
        },
      },
    });
  };
  const changeStatusDocument = (document_id, status) => {
    axiosClient()
      .post(`general/document/${document_id}`, {
        status_id: status,
      })
      .then(() => {
        dispatch({ type: types.RELOAD_DOCUMENTS });
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
    dispatch({
      type: types.CHANGE_INPUT_DOCUMENT_BY_ID,
      payload: { id: document_id, name: "status_id", value: status },
    });
  };
  const addObservation = () => {
    if (state.article.id) {
      axiosClient()
        .post(`inventory/header_item/${state.article.id}/notificated`, {
          note: state.article.observation.text,
        })
        .then(({ data }) => {
          dispatch({
            type: types.CHANGE_INPUT_OBSERVATION,
            payload: { name: "text", value: "" },
          });
          dispatch({ type: types.RELOAD_OBSERTATIONS });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  };

  const checkMeasure = (e, measure_id) => {
    axiosClient()
      .post(`inventory/checkUncheckMeasureItem/${state.article.id}`, {
        measure_id: measure_id,
      })
      .then(({ data }) => {})
      .catch((e) => {
        showTypeErrorFetch(e);
      });
    dispatch({ type: types.CHECK_UNCHECK_MEASURE, payload: measure_id });
  };
  const getInventoryItemByLotesUpdated = ({
    item_id,
    warehouse_id,
    measure_name,
  }) => {
    dispatch({
      type: types.SET_INVENTORY_ITEMS,
      payload: {
        ...state.article.inventory,
        detail_item: {
          ...state.article.inventory.detail_item,
          selected: {
            ...state.article.inventory.detail_item.selected,
            item_id,
            warehouse_id,
            measure_name,
          },
        },
      },
    });
    axiosClient()
      .get(`inventory/getInventoryItemByLotesUpdated/${item_id}/${warehouse_id}`)
      .then(({ data }) => {
        dispatch({
          type: types.SET_INVENTORY_ITEMS,
          payload: {
            ...state.article.inventory,
            detail_item: {
              ...state.article.inventory.detail_item,
              items: data,
              selected: {
                ...state.article.inventory.detail_item.selected,
                item_id,
                warehouse_id,
                measure_name,
              },
            },
          },
        });
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };
  const changeTypeMeasureArticle = (type) => {
    axiosClient()
      .put(`inventory/changeTypeMeasureItem/${state.article.id}`, { type })
      .then(({ data }) => {
        alertSuccess("Medida asignada satisfactoriamente");
        dispatch({
          type: types.CHANGE_OBJECT_ARTICLE,
          payload: {
            ...state.article,
            type,
          },
        });
        dispatch({type: types.MEASURES_CHECK_NOT_LOADED})
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };
  const downloadMovements = () => {
    let token = "";
    let plant = "";
    const Toast = Swal.mixin({
      toast: true,
      background: "#ffffff",
      position: "bottom-end",
      showConfirmButton: false,
    });

    Toast.fire({
      icon: "info",
      title: "Generando documento...",
    });
    if (localStorage) {
      token = localStorage.getItem("token") || "";
    }

    axios
      .create({
        baseURL: process.env.REACT_APP_API_HOST,
        responseType: "blob", // important
        headers: {
          Authorization: token
        },
      })
      .get(`inventory/getMovements/${state.article.id}/excell`, {
        params: state.article.movements.filter,
      })
      .then(({ data }) => {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          Date.now() + "movements.xls"
        );
        document.body.appendChild(link);
        link.click();
        Toast.close();
        alertSuccess("Documento generado");
      })
      .catch((e) => {
        Toast.close();
        showTypeErrorFetch(e);
      });
    }

  const loadDocumentForView = (doc) => {
    const client = axiosClient();
    client
      .get(`general/documentview/${doc.id}`, { responseType: "blob" })
      .then((response) => {
        const mimeType =
          response.headers["content-type"] || "application/pdf";
        const blob = new Blob([response.data], { type: mimeType });
        dispatch({ type: types.SET_SELECTED_PDF, payload: blob });
        alertSuccess("Documento cargado");
      })
      .catch((error) => {
        showTypeErrorFetch(error);
      });
  };

  return (
    <ArticleFormContext.Provider
      value={[
        state,
        dispatch,
        {
          createArticle,
          uploadFilesDataSheet,
          loadArticle,
          changeStatusDocument,
          addObservation,
          checkMeasure,
          getInventoryItemByLotesUpdated,
          changeTypeMeasureArticle,
          downloadMovements,
          loadDocumentForView,
          //getEquivalentValueMainMeasure,
        },
      ]}
    >
      {children}
    </ArticleFormContext.Provider>
  );
};
const useArticle = () => useContext(ArticleFormContext)[0];
const useDispatchArticleForm = () => useContext(ArticleFormContext)[1];
const useActionsArticle = () => useContext(ArticleFormContext)[2];

export {
  ArticleFormContext,
  useArticle,
  useDispatchArticleForm,
  useActionsArticle,
};
export default ArticleFormProvider;
